import { Form } from 'antd';
import { useMemo } from 'react';
import Input from '../../../../Input';
import { countries } from './countries';

interface IProps {
  name?: string[];
}

const InternationalAddress = ({ name }: IProps) => {
  name = name ?? [];

  const filterOption = (input: string, option: any) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const mappedCountries = useMemo(() => {
    return countries.map((country) => ({
      label: country.name,
      value: country.code,
    }));
  }, []);

  return (
    <>
      <div className='grid grid-cols-1 sm:grid-cols-2 sm:gap-4'>
        <Form.Item
          label="Postal Code"
          name={[...name, 'postalCode']}
          rules={[
            {
              required: true,
              message: 'Por favor, digite o seu Postal Code!',
            },
          ]}
        >
          <Input placeholder="Digite seu Postal Code" />
        </Form.Item>

        <Form.Item
          label="País"
          name={[...name, 'country']}
          rules={[
            {
              required: true,
              message: 'Por favor, selecione seu país!',
            },
          ]}
        >
          <Input.Select
            showSearch
            placeholder="Selecione um país"
            optionFilterProp="children"
            filterOption={filterOption}
            options={mappedCountries}
          />
        </Form.Item>
      </div>

      <Form.Item
        label="Endereço"
        name={[...name, 'street']}
        rules={[
          {
            required: true,
            message: 'Por favor, digite seu endereço!',
          },
        ]}
      >
        <Input placeholder="Digite seu endereço" />
      </Form.Item>

      <div className='grid grid-cols-1 sm:grid-cols-2 sm:gap-4'>
        <Form.Item
          label="Cidade"
          name={[...name, 'city']}
          rules={[{ required: true, message: 'Por favor, digite a cidade!' }]}
        >
          <Input placeholder="Digite sua cidade" />
        </Form.Item>

        <Form.Item
          label="Estado"
          name={[...name, 'state']}
          rules={[
            {
              required: true,
              message: 'Por favor, digite o seu estado!',
            },
          ]}
        >
          <Input placeholder="Digite seu estado" />
        </Form.Item>
      </div>
    </>
  );
};

export default InternationalAddress;
